import { css, type ExecutionContext } from 'styled-components'

type CustomAlignProps = {
  left?: boolean
  center?: boolean
  right?: boolean
}

const leftCss = ({ left }: ExecutionContext & { left?: boolean }) =>
  left &&
  css`
    text-align: left;
  `

const centerCss = ({ center }: ExecutionContext & { center?: boolean }) =>
  center &&
  css`
    text-align: center;
  `

const rightCss = ({ right }: ExecutionContext & { right?: boolean }) =>
  right &&
  css`
    text-align: right;
  `

export type { CustomAlignProps }
export { centerCss, leftCss, rightCss }
